import { IGetObraChecklistServicoLiberacaoByIdUseCase } from "../../../presentation/useCases/read/get_obra_checklist_servico_liberacao_by_id_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

export class GetObraChecklistServicoLiberacaoByIdUseCase implements IGetObraChecklistServicoLiberacaoByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(idObraChecklistServico: number, idChecklistServico: number) {
    return await this.repository.getObraChecklistServicoLiberacaoById(idObraChecklistServico, idChecklistServico);
  }
}
